import { render, staticRenderFns } from "./OutwardsPremComm.vue?vue&type=template&id=04636e10&"
import script from "./OutwardsPremComm.vue?vue&type=script&lang=js&"
export * from "./OutwardsPremComm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports